/*
 * Copyright (c) 2018 Integral Agile, Inc. All rights reserved.
 *   Use of this file is subject to the terms and conditions defined in the file
 * 'LICENSE.txt'
 *   which is distributed in the root directory of this source code tree.
 */

import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import holonButton from '../../../assets/images/holon-button.png';

const Holon = ({ action, disabled, mouseEnter, mouseLeave, classes = '' }) => (
  <div className="holon-wrapper">
    {typeof action === 'function' ? (
      <button
        type="button"
        className={`btn btn-link ${classes}`}
        onClick={action}
        disabled={disabled}
        onMouseEnter={mouseEnter}
        onMouseLeave={mouseLeave}
      >
        <img src={holonButton} className="holon-btn" alt="holon button" />
      </button>
    ) : (
      <Link
        to={{
          pathname: action,
          state: { prevUrl: window.location.pathname }
        }}
        className={`${classes} ${disabled ? 'disable-click' : ''}`}
        onMouseEnter={mouseEnter}
        onMouseLeave={mouseLeave}
      >
        <img src={holonButton} className="holon-btn" alt="holon button" />
      </Link>
    )}
  </div>
);

Holon.propTypes = {
  action: PropTypes.any, // action can be a function or a link
  disabled: PropTypes.bool,
  mouseEnter: PropTypes.func,
  mouseLeave: PropTypes.func
};

Holon.defaultProps = {
  action: () => null,
  disabled: false,
  mouseEnter: () => null,
  mouseLeave: () => null
};

export default Holon;
